import type {ReactElement} from 'react';
import React from 'react';
import type {SocialAccount} from '@Components/social-media/account.vo';
import {isFacebookAccount} from '@Components/social-media/account.vo';
import {SocialPlatform} from '@Components/social-media/social-media.types';
import {SocialProfileIcon, SocialProfileIconSize} from '@Components/social-media/components/social-profile-icon';
import {SocialThumbnail} from '@Components/social-media/components/social-thumbnail';
import {Text, TextSize} from '@Components/text';
import {PlatformMediaType} from '@Components/social-media/post.vo';
import styles from './social-post-content-story-top-panel.module.scss';

// Note - Currently, Story publishing is only available for Instagram & Facebook
export interface SocialPostContentStoryTopPanelProps {
  account: SocialAccount;
}

export function SocialPostContentStoryTopPanel({account}: SocialPostContentStoryTopPanelProps): ReactElement<any> {
  const getProgressClassesByaccountType = (): string => {
    if (isFacebookAccount(account)) {
      return `${styles.facebook}`;
    }

    if (account.type === SocialPlatform.INSTAGRAM) {
      return `${styles.instagram}`;
    }

    return '';
  };

  const renderStaticStoryProgress = (): ReactElement<any> => {
    return (
      <div className={`${styles.storyProgress} ${getProgressClassesByaccountType()}`}>
        <div className={styles.storyProgressCovered} />
      </div>
    );
  };

  const getPlaceholderAccountLoaderForFacebook = (): ReactElement<any> | null => {
    if (isFacebookAccount(account)) {
      return (
        <>
          <div className={styles.leftPanel}>
            <div className="flex-row-align-center">
              <div className="spacing-m-r-2">
                <SocialProfileIcon account={account} size={SocialProfileIconSize.LARGE} showPlatformIcon={false} />{' '}
              </div>
              <div className={`${styles.postInfoHorizontal} _fit-width _full-height _fit-width _full-height`}>
                <Text val={`${account?.name}  `} className="content-body-white" bold />
                <Text val={`${window.i18next.t('pmwjs_time_placeholder')}`} className="content-body-white" size={TextSize.XXSMALL} />
              </div>
            </div>
          </div>

          <div className={styles.rightPanel}>{getAccountIcon()}</div>
        </>
      );
    }

    return null;
  };

  const getAccountIcon = (): ReactElement<any> => {
    return <SocialThumbnail shouldShowBorder platformMediaType={PlatformMediaType.STORIES} isActive={false} customClasses={styles.thumbClasses} type={account.type} />;
  };

  const getAccountInformationforInstagram = (): ReactElement<any> | null => {
    if (account.type === SocialPlatform.INSTAGRAM) {
      return (
        <>
          <div className={styles.instagramLeftPanel}>
            <SocialProfileIcon className={styles.profileIconClasses} account={account} size={SocialProfileIconSize.LARGE} showPlatformIcon={false} />
            <Text bold size={TextSize.XXSMALL} className="content-body-white spacing-m-r-2" val={account.name} />
            <Text val={`${window.i18next.t('pmwjs_time_placeholder')}`} className="content-body-white" size={TextSize.XXSMALL} />
          </div>
          <div className={styles.instagramRightPanel}>{getAccountIcon()}</div>
        </>
      );
    }

    return null;
  };

  const getAccountInformation = (): ReactElement<any> => {
    return (
      <div className={styles.accountInformationParent}>
        <div className={styles.topPanel}>
          {getPlaceholderAccountLoaderForFacebook()}
          {getAccountInformationforInstagram()}
        </div>
      </div>
    );
  };

  const getOverlay = (): ReactElement<any> => {
    return <div className={styles.overlay} />;
  };

  return (
    <div className={styles.topPanelWrapper}>
      {renderStaticStoryProgress()} {getAccountInformation()}
      {getOverlay()}
    </div>
  );
}
